import getter from "@/store/getter";
import Vue from "vue";
import getters from "../auth/getters";
import eventAnalysis from "./analysis";
import state from "./state";
import { getfilterDataForDate } from "../../../store/util";
import provider from ".";

export default {
  getProvider(state) {
    return state.provider;
  },

  getCurrentProvider(state) {
    return state.id;
  },
  /**
   * Checks if a single provider is chosen or
   * all of them all
   */
  allPatientsChosen() {
    return state.id ? false : true;
  },

  getProviderList(state) {
    return state.providers;
  },
  /**
   * Gets a list of providers ids as a array
   */
  getProvidersIdArray(state) {
    return state.providers.map((provider) => provider.provider);
  },

  getProviderName(state) {
    if (state.provider) return state.provider.name;
  },
  getProviderNameById(state) {
    return (providerId) => {
      if (providerId && providerId.includes(":")) providerId = providerId.split(":")[0];
      if (state.providers) {
        const provider = state.providers.find(
          (provider) => provider.provider === providerId
        );
        if (provider) return provider.name;
      }
      return "";
    };
  },

  getSchedule(state) {
    return state.schedule;
  },

  getPatients(state) {
    return state.patient;
  },

  getEvents(state) {
    return state.event;
  },

  getFilter(state) {
    return (id) => {
      if (state.provider && state.provider.filter)
        return state.provider.filter.find((filter) => filter.id === id);
      return null;
    };
  },

  getFilterArg(state) {
    return (id) => {
      if (!state.filterArg[id]) Vue.set(state.filterArg, id, {});
      return state.filterArg[id];
    };
  },

  getQuestionnaire(state) {
    return (id) => state.surveyRecord[id];
  },

  getPatient(state) {
    return (id) => state.patient[id];
  },

  getPatientRecommendation(state) {
    return (id) => {
      return state.record.recommendation[id]
    }
  },

  getPatientProviderProfileList(state, getters) {
    return (id) => {
      try {
        let list = [];
        const patient = state.patient[id],
          currentProviderId = state.id;
        if (patient && patient.profile_map) {
          list = patient.profile_map
            .filter((profileProvider) => {
              if (currentProviderId)
                return profileProvider.includes(currentProviderId);
              else
                return getters.getProvidersIdArray.some((providerId) =>
                  profileProvider.includes(providerId)
                );
            })
            .map((profileProvider) => ({
              profile: profileProvider.split(":")[1],
              provider: profileProvider.split(":")[0],
            }));
        } else if (patient)
          list = [
            {
              profile: patient.profile[0],
              provider: patient.provider[0],
            },
          ];
        return list;
      } catch (error) {
        console.error("Problem getting providerProfileList", error);
        return [];
      }
    };
  },

  getPatientSchedule(state) {
    return (id) => {
      let patientSchedule = state.record.schedule[id];
      if (state.id)
        patientSchedule = patientSchedule.filter(({ provider }) =>
          provider.includes(state.id)
        );
      return getfilterDataForDate(patientSchedule, state);
    };
  },

  getPatientEvents(state) {
    return (id) => getfilterDataForDate(state.record.event[id], state) || [];
  },

  getPatientEventAnalysis(state, patientId, rootState) {
    return (id) =>
      eventAnalysis(state.record.event[id], rootState.content.data);
  },

  getPatientLoadingState(state) {
    return (id) => state.loadingPatient[id];
  },

  getPatientSchedulingState(state) {
    return (id) => state.schedulingPatient[id];
  },

  getPatientMessagingState(state) {
    return (id) => state.messagingPatient[id];
  },

  getPatientMessages(state) {
    return (id) => getfilterDataForDate(state.record.message[id], state);
  },

  getPatientMessage(state) {
    return (id, messageId) =>
      state.record.message[id].find((message) => message.id === messageId);
  },

  getPatientTickets(state) {
    return (id) => getfilterDataForDate(state.record.ticket[id], state);
  },

  getPatientFiles(state) {
    return (id) =>
      getfilterDataForDate(state.record.file[id], state).sort(
        (a, b) =>
          (b.modified_time || b.created) - (a.modified_time || a.created)
      );
  },

  getPatientRecords(state) {
    return (id) =>
      getfilterDataForDate(state.record.record[id], state).sort(
        (a, b) =>
          (b.modified_time || b.created) - (a.modified_time || a.created)
      );
  },

  getPatientSurveys(state) {
    return (id) => getfilterDataForDate(state.record.survey[id], state);
  },

  getPatientList(state, getters) {
    return getters.getAllProviderPatientList;
  },

  getPatientMap(state) {
    return state.patient;
  },

  getSurveyState(state) {
    return state.surveyState || {};
  },

  getPatientsByName(state, getters) {
    return getters.getPatientList.sort((a, b) => a.name.localeCompare(b.name));
  },

  getPatientsByLastName(state, getters) {
    return getters.getPatientList.sort((a, b) =>
      a.family_name ? a.family_name.localeCompare(b.family_name) : 0
    );
  },

  getPatientsByActivity(state, getters) {
    return getters.getPatientList.sort((a, b) => a.activity - b.activity);
  },

  searchPatients(state) {
    return (search, query) => {};
  },
  getTagToColorMapping(state) {
    if (state) return state.patientTagToColorMapping;
    return [];
  },
  getProviderProfileList(state) {
    if (state.provider) {
      return state.provider.profile;
    }
    return null;
  },
  getAllProviderProfileList(state) {
    if (state.providers && Array.isArray(state.providers)) {
      return state.providers.flatMap((provider) => {
        const providerId = provider.provider,
          providerName = provider.name;
        return provider.hasOwnProperty("profile")
          ? provider.profile.map(({ id, title, event }) => ({
              id,
              title,
              event: [...event],
              providerId,
              providerName,
            }))
          : [];
      });
    }
    return null;
  },
  getAllProviderPatientList(state) {
    const patientList = state.providerPatients.flatMap((provider) =>
      provider.patient.map((patient) => ({
        ...patient,
        providerId: [provider.id],
        next_schedule: patient.next_schedule ? patient.next_schedule : null,
      }))
    )
    return Object.values(
      patientList.reduce((acc, patient) => {
        if (!acc[patient.id]) {
          acc[patient.id] = patient
        } else {
          acc[patient.id].providerId.push(...patient.providerId)
          if (!acc[patient.id].next_schedule || !patient.next_schedule) {
            acc[patient.id].next_schedule =
              acc[patient.id].next_schedule || patient.next_schedule
            if (
              patient.next_schedule &&
              patient.progress &&
              patient.progress.total !== 0
            )
              Vue.set(acc[patient.id], "progress", patient.progress);
          } else {
            acc[patient.id].next_schedule =
              acc[patient.id].next_schedule < patient.next_schedule
                ? acc[patient.id].next_schedule
                : patient.next_schedule
            let progress =
              acc[patient.id].next_schedule < patient.next_schedule
                ? acc[patient.id].progress
                : patient.progress
            Vue.set(acc[patient.id], "progress", progress)
          }
        }
        return acc
      }, {})
    )
  },
  getProviderPatientList(state) {
    return state.providerPatients;
  },
  getProviderProfile: (state) => (profileId) => {
    if (!state.provider) {
      return null;
    }
    return state.provider.profile.find((profile) => profile.id === profileId);
  },
  getTicketPatientByType(state) {
    return (ticketCategoryId) => {
      return state.providers.reduce(
        (countAcc, { provider }) => {
          const providerTickets = state.tickets.find(
            ({ id }) => id === provider
          );
          if (providerTickets) {
            const authList = providerTickets.tickets
              .filter(
                ({ category_id, status }) =>
                  category_id === ticketCategoryId && status !== "closed"
              )
              .map(({ auth }) => auth);
            countAcc[provider] = [...new Set(authList)].length;
            countAcc["total"] = [
              ...new Set(countAcc["total"].concat(authList)),
            ];
          }
          return countAcc;
        },
        { total: [] }
      );
    };
  },
  getPatientCreationTime(state) {
    return (id) => {
      if (state.patient[id]) return state.patient[id].created;
      return null;
    };
  },
};
